import React from 'react';
import { ComponentTypeNames } from '../../../schema';
import { DatoCmsInformationSectionComponent, InfoSectionItems } from '../../../schema/datocms';
import { DatoCmsInformationSectionComplexImage, DatoCmsInformationSectionImage, DatoCmsInformationSectionRichText, DatoCmsInformationSectionVideo, DatoCmsTwoColumnInformationCard, DatoCmsTwoColumnRichText } from '../../../schema/datocms/blocks';
import { DatoCmsInformationSectionAccordion } from '../../../schema/datocms/blocks/information-section-accordion';
import { getColumnSpanClass, getColumnStartClass, getFlexJustification, getTextAlignmentClass } from '../../../utilities';
import InformationSectionAccordionComponent from '../../block-components/information-section-accordion-component/information-section-accordion-component';
import InformationSectionComplexImageComponent from '../../block-components/information-section-complex-image-component/information-section-complex-image-component';
import InformationSectionImageComponent from '../../block-components/information-section-image-component/information-section-image-component';
import InformationSectionRichTextComponent from '../../block-components/information-section-rich-text-component/information-section-rich-text-component';
import InformationSectionVideoComponent from '../../block-components/information-section-video-component/information-section-video-component';
import TwoColumnInformationCardComponent from '../../block-components/two-column-information-card-component/two-column-information-card-component';
import TwoColumnRichTextComponent from '../../block-components/two-column-rich-text-component/two-column-rich-text-component';
import Button from '../../button/button';
import HtmlEntityTextComponent from '../../html-entity-text/html-entity-text-component';
import { useThemeClassMap } from '../../theme/useThemeClassMap';

const InformationSectionComponent = (
    { title, theme, button, buttonAlignment,
        titleAlignment, informationItems
    }: DatoCmsInformationSectionComponent
): React.ReactElement => {
    const themeClass = useThemeClassMap(theme);

    function informationItemMapper(block: InfoSectionItems): React.ReactElement | null {
        switch (block.__typename) {
            case ComponentTypeNames.TWO_COLUMN_INFO_CARD:
                return <TwoColumnInformationCardComponent {...block as DatoCmsTwoColumnInformationCard} />;
            case ComponentTypeNames.TWO_COLUMN_RICH_TEXT:
                return <TwoColumnRichTextComponent {...block as DatoCmsTwoColumnRichText} />;
            case ComponentTypeNames.INFO_SECTION_RICH_TEXT:
                return <InformationSectionRichTextComponent {...block as DatoCmsInformationSectionRichText}  />;
            case ComponentTypeNames.INFO_SECTION_VIDEO:
                return <InformationSectionVideoComponent {...block as DatoCmsInformationSectionVideo} />;
            case ComponentTypeNames.INFO_SECTION_IMAGE:
                return <InformationSectionImageComponent {...block as DatoCmsInformationSectionImage} />;
            case ComponentTypeNames.INFO_SECTION_COMPLEX_IMAGE:
                return <InformationSectionComplexImageComponent {...block as DatoCmsInformationSectionComplexImage} />;
            case ComponentTypeNames.INFO_SECTION_ACCORDION:
                return <InformationSectionAccordionComponent {...block as DatoCmsInformationSectionAccordion} />;
            default:
                console.warn('Unsupported Information Section Item', block.__typename);
                return null;
        }
    }

    return (
        <div className={`${ themeClass } page-component`}>
            <div className="container mx-auto">
                { title && <h2 className={`${getTextAlignmentClass(titleAlignment)} mb-8`}>
                    { <HtmlEntityTextComponent text={title} /> }
                </h2> }

                <div className="space-y-16">
                    {
                        informationItems.map((block, index) => {
                            const gridColumnSpanClass: string = getColumnSpanClass(block.columnLayout);
                            const gridColumnStartClass: string = getColumnStartClass(block.columnLayout);

                            return (
                                <div key={index} className="container lg:grid lg:grid-cols-12">
                                    <div className={`lg:${gridColumnSpanClass} lg:${gridColumnStartClass}`}>
                                        { informationItemMapper(block) }
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>

                {
                    button && button.length > 0 &&
                    <div className={`mt-12 flex justify-center md:${getFlexJustification(buttonAlignment)}`}>
                        <Button {...button[0]} className='text-center'/>
                    </div>
                }
            </div>
        </div>
    );
};

export default InformationSectionComponent;
